import { pathOr } from 'ramda'
// tslint:disable-next-line
const URLSearchParams = require('url-search-params')

export const getFromEnv = (key: any, d?: any) => pathOr(d, ['env', key])(process)

interface ICentre {
    domains: string[]
    storyblokAccessToken: string
    storyblokSharedAccessToken: string
    registrationApiUrl: string
    centreId: string
    name: string
}

interface IEnvironmentConfiguration {
    recaptchaKey?: string
    centres: ICentre[]
    isConcierge: string
    isMaintenanceMode?: string
}

let environmentConfiguration: IEnvironmentConfiguration = { centres: [], isConcierge: 'true' }

if (process.env.REACT_APP_ENVIRONMENT_CONFIGURATION !== undefined) {
    environmentConfiguration = JSON.parse(process.env.REACT_APP_ENVIRONMENT_CONFIGURATION)
}

const domain = window.location.hostname.toLowerCase()
const currentEnvironment = environmentConfiguration.centres.find(centre => centre.domains.indexOf(domain) !== -1)

export const isReCaptchaEnabled = () => {
    if (!currentEnvironment) {
        return false
    }

    return !!(environmentConfiguration.recaptchaKey && environmentConfiguration.recaptchaKey !== '')
}

export const recaptchaKey = environmentConfiguration.recaptchaKey
export const isConcierge = environmentConfiguration.isConcierge
export const isMaintenanceMode = !!environmentConfiguration.isMaintenanceMode
export const get = (key: string) => currentEnvironment !== undefined ? currentEnvironment[key] : ''

const DEFAULT_THANKYOU_PAGE_TIMEOUT = 60 * 1000

export const getTimout = (): number => {
    const params = new URLSearchParams(document!.location!.search);

    return params.get('timeout')
        ? parseInt(params.get('timeout') as string, 10) * 1000
        : DEFAULT_THANKYOU_PAGE_TIMEOUT
}



// WEBPACK FOOTER //
// ./src/lib/config.tsx